<template>
  <div class="container-fluid mt-2">
    <h2>System-Konfiguration</h2>
    <br/>
    <b-tabs content-class="mt-3">
      <b-tab title="Allgemein">
        <CommonConfig/>
      </b-tab>
      <b-tab title="Synchronisation">
        <SyncSchedule/>
      </b-tab>
      <b-tab title="Berichte">
        <ReportsConfig/>
      </b-tab>
      <b-tab title="E-Mail">
        <EmailConfig/>
      </b-tab>
      <b-tab title="iHand">
        <iHandConfig/>
      </b-tab>
      <b-tab title="Individuelle">
        <FirmConfigView/>
      </b-tab>
      <b-tab title="Aktionscodes">
        <GiftCardConfig/>
      </b-tab>
      <b-tab title="Geo Coding">
        <GeoCodingRule/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ReportsConfig from '@/components/admin/ReportsConfig.vue'
import CommonConfig from '@/components/admin/CommonConfig.vue'
import SyncSchedule from '@/components/admin/SyncSchedule.vue'
import iHandConfig from '@/components/admin/iHandConfig.vue'
import EmailConfig from '@/components/admin/EmailConfig.vue'
import GeoCodingRule from '@/components/admin/GeoCodingRule.vue'
import GiftCardConfig from '@/components/admin/GiftCardConfig.vue'
import FirmConfigView from '@/views/admin/FirmConfigView.vue'

export default {
  name: 'ConfigView',
  components: {
    ReportsConfig,
    CommonConfig,
    SyncSchedule,
    iHandConfig,
    GeoCodingRule,
    EmailConfig,
    GiftCardConfig,
    FirmConfigView
  }
}
</script>
